import * as WIApiUtil from "../../util/wi_util";
export const RECEIVE_ALL_WORK_INSTRUCTIONS = "RECEIVE_ALL_WORK_INSTRUCTIONS"
export const RECEIVE_RELEASED_WORK_INSTRUCTIONS = "RECEIVE_RELEASED_WORK_INSTRUCTIONS"
export const EDIT_WORK_INSTRUCTION = "EDIT_WORK_INSTRUCTION"
export const UPDATE_WORK_INSTRUCTION = "UPDATE_WORK_INSTRUCTION"
export const ADD_WORK_INSTRUCTION = "ADD_WORK_INSTRUCTION"
export const REMOVE_WORK_INSTRUCTION = "REMOVE_WORK_INSTRUCTION"
export const UPDATED_RELEASED_WORK_INSTRUCTIONS = "UPDATED_RELEASED_WORK_INSTRUCTIONS"
export const LOAD_WORK_INSTRUCTION = "LOAD_WORK_INSTRUCTION"
export const RECEIVE_WI_ERRORS = "RECEIVE_WI_ERRORS"
export const NULL_ERRORS = "NULL_ERRORS"
export const SUBMIT_FORM_ERRORS = "SUBMIT_FORM_ERRORS"
export const RESET_AUTHOR = "RESET_AUTHOR"
export const ADDTAB = "ADDTAB"



export const receiveErrors = errors => ({
    type: RECEIVE_WI_ERRORS,
    errors
});

export const nullErrors = () => ({
    type: NULL_ERRORS
})

export const resetAuthor = () => ({
    type: RESET_AUTHOR
})

export const addTab =(title,wip_ID)=>{
    return{
       type:ADDTAB,
       title,
       wip_ID 
    }
    
};

export const receiveAllWorkInstructions = (workInstructions) => {
    return {
        type: RECEIVE_ALL_WORK_INSTRUCTIONS,
        workInstructions
    }
}
export const receiveReleasedWorkInstructions = (workInstructions) => {
    return {
        type: RECEIVE_RELEASED_WORK_INSTRUCTIONS,
        workInstructions
    }
}

export const returnUpdatedWip  = wip => {
    return {
        type: UPDATED_RELEASED_WORK_INSTRUCTIONS,
        workInstruction: wip,
    };
};

export const addWorkInstruction = (workInstruction) => {
    return {
        type: ADD_WORK_INSTRUCTION,
        workInstruction
    }
}

export const selectWorkInstruction = (workInstruction) => {    
    return {
        type: EDIT_WORK_INSTRUCTION,
        workInstruction
    }
}
export const loadWorkInstruction = (workInstruction) => {
    return {
        type: LOAD_WORK_INSTRUCTION,
        workInstruction
    }
}

export const updateWorkInstruction = (updatedWorkInstruction) => {
    return {
        type: UPDATE_WORK_INSTRUCTION,
        updatedWorkInstruction
    }
}

const removeWorkInstruction = workInstruction => {
    return {
        type: REMOVE_WORK_INSTRUCTION,
        workInstruction
    }
}

export const fetchAllWorkInstructions = (cancelToken) => dispatch => {
    return WIApiUtil.fetchAllWorkInstructions(cancelToken)
        .then(workInstructions => dispatch(receiveAllWorkInstructions(workInstructions)) )
};

export const fetchReleasedWorkInstructions = (cancelToken) => dispatch => {
    return WIApiUtil.fetchReleasedWorkInstructions(cancelToken)
        .then(workInstructions => dispatch(receiveReleasedWorkInstructions(workInstructions)) )
};



export const editWorkInstruction = (WIID, property) => dispatch => {
    return WIApiUtil.fetchWorkInstruction(WIID).then(workInstruction => property ? 
            dispatch(updateWorkInstruction(workInstruction)) 
            : 
            dispatch(selectWorkInstruction(workInstruction.data))
        );
};

export const saveWorkInstruction = (updatedWorkInstruction) => dispatch => {
    return WIApiUtil.updateWorkInstruction(updatedWorkInstruction).then(workInstruction => {
        //use this once backend returns updated work instruction
        // return dispatch(updateWorkInstruction(workInstruction.data))
        // console.log("return from api tp update wi")
        // console.log(workInstruction)
        return dispatch(updateWorkInstruction(updatedWorkInstruction))
    }
    );
};

export const previewWorkInstruction = (WIID) => dispatch => {
    return WIApiUtil.fetchWorkInstruction(WIID).then(workInstruction => 
        dispatch(loadWorkInstruction(workInstruction.data))
    );
}


export const deleteWorkInstruction = (workInstructionId) => dispatch => {
    return WIApiUtil.deleteWorkInstruction(workInstructionId)
        .then(wip => {
            let updatedData = {
                tags: wip.data.tags,
                wip_id: wip.data._id
            }
            return dispatch(removeWorkInstruction(updatedData))
        }
        )
};

export const cloneWorkInstruction = (workInstructionId) => dispatch => {
    return WIApiUtil.cloneWorkInstruction(workInstructionId)
        .then(workInstruction =>
            dispatch(addWorkInstruction(workInstruction.data))
        )
        .catch(err => {
            dispatch(receiveErrors(err.response.data));
        })
};

export const createWorkInstruction = (workInstructionPayload, path,clone) => dispatch => (
    WIApiUtil.createWorkInstruction(workInstructionPayload, path,clone)
        .then(workInstruction => 
            dispatch(addWorkInstruction(workInstruction.data))
        )
    .catch(err => {
        dispatch(receiveErrors(err.response.data));
    })
)
export const checkNameAvailability = (title) => dispatch => (
    WIApiUtil.checkNameAvailability(title)
        .then(response => {
            if (response.data === "Available") {
                return true
            } else {
                return false
            }})
)

export const convertPDF = (fd, cb) => dispatch => {
    return WIApiUtil.convertPDF(fd, cb)
        .then(wi => {
            dispatch(addWorkInstruction(wi.data))
            return wi.data
        })
};

export const uploadPDF = (fd, cb) => dispatch => {
    return WIApiUtil.uploadPDF(fd, cb)
        .then(wi => {
            dispatch(addWorkInstruction(wi.data))
            return wi.data
        })
};



export const submitFormError = (error) => dispatch => (
    dispatch(receiveErrors(error))
)

export const clearFormErrors = () => dispatch => (
    dispatch(nullErrors())
)

export const clearAuthor = () => dispatch => (
    dispatch(resetAuthor())
)